import { createContext, useContext, useCallback } from 'react';
import { generatePath, useHistory } from 'quartz-routing/react-router';
import { ROUTES } from '../constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
const NavigationContext = /*#__PURE__*/createContext(null);
export function NavigationProvider({
  children
}) {
  const history = useHistory();
  const toListings = useCallback(() => {
    history.push(ROUTES.root);
  }, [history]);
  const toNewTicket = useCallback(() => {
    history.push(ROUTES.new);
  }, [history]);
  const toTicketDetails = useCallback((ticketId, threadId) => {
    history.push(generatePath(ROUTES.ticket, {
      ticketId,
      threadId
    }));
  }, [history]);
  return /*#__PURE__*/_jsx(NavigationContext.Provider, {
    value: {
      toListings,
      toNewTicket,
      toTicketDetails
    },
    children: children
  });
}
export function useNavigationContext() {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationProvider');
  }
  return context;
}